exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* Keep only the modern footer on activate page */\n.app-container.activate .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
